import { Action } from '@wix/component-protocol/schema';
import { IEditActionBuilder } from '../types';
import { createCustomActionExecute } from './actionHandlers';
import { getActionId } from '../utils/getActionId';

export class CustomActionBuilder extends IEditActionBuilder {
  private isValidCustomAction(
    actionDefinition: Action,
  ): actionDefinition is Required<Action> {
    return Boolean(actionDefinition.displayName && actionDefinition.execution);
  }

  build(actionName: string, actionDefinition: Action) {
    if (!this.isValidCustomAction(actionDefinition)) {
      return null;
    }

    const actionId = getActionId('custom', actionName);
    const context = this.ctx.createExtendedPlatformContext(
      actionName,
      actionDefinition,
    );
    const { execution, ...definition } = actionDefinition;

    return {
      actionId,
      actionName,
      ...definition,
      execute: createCustomActionExecute(
        actionName,
        actionDefinition,
        actionId,
        context,
      ),
    };
  }
}
